import { environment } from 'src/environments/environment';

export const cUser = {
    updateProfile: "usuario/actualizarPerfil",
    updateUser: "usuario/actualizar",
    UpdateImage: "usuario/actualizarFoto/",
    storageImage: environment.baseStorageUrl
}